export enum PERMISSIONS {
  SPECIFICATIONS = "Specifications",
  DOCUMENTS = "Documents",
  DONOR = "Donor",
}
